import { useRouter } from "next/router";
import { partnerThemes, PartnerTheme } from "../config/partnerThemes";

export const usePartnerTheme = (): PartnerTheme | null => {
  const { asPath } = useRouter();

  return (
    partnerThemes.find((theme) =>
      theme.paths.some((path) => asPath.startsWith(path))
    ) ?? null
  );
};
